import React, { useEffect, useState } from "react";

import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";

import { Helmet } from "react-helmet";

const TermsConditions = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText = "Benefits of Membership ";

  const title = "Terms and Conditions";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.1, // Delay each letter animation
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <style
        dangerouslySetInnerHTML={{
          __html: `
      @media screen and (max-width: 425px) {
        .page_title {
          font-size: 36px;
          line-height: 56px;
        }
      }
    `,
        }}
      />

      <Helmet>
        {/* Basic Meta Tags */}
        <title> Terms and Conditions | MSB Association</title>
        <meta
          name="description"
          content="Read MSB Association’s Terms and Conditions to understand our policies, membership guidelines, and usage of our services and resources."
        />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Terms and Conditions | MSB Association "
        />
        <meta
          property="og:description"
          content="Read MSB Association’s Terms and Conditions to understand our policies, membership guidelines, and usage of our services and resources."
        />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section
          id="Terms and Conditions"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{
                display: "flex",
                flexDirection: "column", // stack lines vertically
                alignItems: "center",
                textAlign: "center",
                flexWrap: "wrap",
              }}
            >
              {title
                .replace(/\/n/g, "\n") // Convert "/n" to actual line breaks
                .split("\n")
                .map((line, lineIndex) => (
                  <div
                    key={`line-${lineIndex}`}
                    style={{
                      display: "flex",
                      flexWrap: "wrap", // ensure words wrap on smaller screens
                      justifyContent: "center",
                    }}
                  >
                    {line.split("").map((letter, charIndex) => {
                      const uniqueIndex = lineIndex * 30 + charIndex;
                      return (
                        <motion.span
                          key={`char-${lineIndex}-${charIndex}`}
                          custom={uniqueIndex}
                          initial="hidden"
                          animate="visible"
                          variants={letterVariants}
                          style={{
                            display: "inline-block",
                            marginRight: letter === " " ? "0.3rem" : "0",
                            whiteSpace: "pre",
                          }}
                        >
                          {letter}
                        </motion.span>
                      );
                    })}
                  </div>
                ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li className="mb-2 mt-2">
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="active">
                <a href="#!">Terms and Conditions</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content p-3">
              {/* <h2 className="item_details_heading" id="RegulatoryComplianceSupport">
              {headingText.split("").map((char, i) => (
              <motion.span
                key={`${char}-${i}`}
                custom={i}
                initial="hidden"
                animate="visible"
                variants={headingVariants}
              >
                {char}
              </motion.span>
            ))}
              </h2> */}
              {/* <p >
    Becoming a member of the MSB Association offers numerous advantages that can help your Money Service Business thrive in a competitive environment. Here are some key benefits:
    </p> */}

              <h5 className="mb-3">Introduction</h5>
              <p>
                These Terms and Conditions govern the use of services provided
                by the MSB Association (&quot;the Association&quot;). By
                accessing or using our services, you agree to comply with these
                terms.
              </p>
              <h5 className="mb-3">Purpose</h5>
              <p className="mb-2">
                The MSB Association is a non-profit association dedicated to
                supporting Money Service Businesses (MSBs) through:
              </p>
              <ul
                className="mb-3 mt-3"
                style={{ fontSize: "18px", fontWeight: "600" }}
              >
                <li className="mb-2 mt-2">Advocacy</li>
                <li className="mb-2 mt-2">Education</li>
                <li className="mb-2 mt-2">Networking</li>
                <li className="mb-2 mt-2">Resources</li>
              </ul>
              <h5>Membership</h5>
              <ul
                className="mb-3 mt-3"
                style={{ fontSize: "18px", fontWeight: "600" }}
              >
                <li className="mb-2 mt-2">
                  Eligibility: Membership is open to individuals and entities
                  involved in or supporting the Money Service Business sector or
                  any Affiliate sector
                </li>
                <li className="mb-2 mt-2">
                  Application: Interested individuals or entities must complete
                  a membership application.
                </li>
                <li className="mb-2 mt-2">
                  Membership fees are GBP 199 annually and should be paid
                  upfront.
                </li>
                <li className="mb-2 mt-2">
                  Withdrawal: Members may withdraw from the Association at any
                  time by providing written notice to the Board before 2 weeks.
                  Upon withdrawal, any paid membership fees will be refunded
                  based on the number of active membership days.
                </li>
              </ul>
              <h5 className="mb-3">Code of Conduct</h5>
              <h6 className="mb-4 mt-4">Members are expected to:</h6>
              <ul
                className="mb-3 mt-3"
                style={{ fontSize: "18px", fontWeight: "600" }}
              >
                <li className="mb-2 mt-2">
                  Act in a professional and respectful manner.
                </li>
                <li className="mb-2 mt-2">
                  Uphold the values and mission of the Association.
                </li>
                <li className="mb-2 mt-2">
                  Avoid conflicts of interest and disclose any potential
                  conflicts
                </li>
              </ul>

              <h5>Prohibited Use</h5>
              <h6 className="mb-4 mt-4">
                Members and users are prohibited from:
              </h6>
              <ul
                className="mb-3 mt-3"
                style={{ fontSize: "18px", fontWeight: "600" }}
              >
                <li className="mb-2 mt-2">
                  Engaging in any unlawful activities.
                </li>
                <li className="mb-2 mt-2">
                  Using the Association&#39;s services or materials for
                  commercial purposes without prior written consent.
                </li>
                <li className="mb-2 mt-2">
                  Disrupting or interfering with the security or integrity of
                  the Association&#39;s website or services.
                </li>
              </ul>

              <h5>Links to Other Websites</h5>
              <p>
                Our website may contain links to third-party websites. The
                Association does not endorse or assume any responsibility for
                the content, privacy policies, or practices of these websites.
                Users are encouraged to review the terms and conditions of any
                third-party site they visit.
              </p>
              <h5>Limitation of Liability</h5>
              <p>
                The Association shall not be liable for any direct, indirect,
                incidental, or consequential damages arising from the use of our
                services or participation in our activities.
              </p>
              <h5>Intellectual Property</h5>
              <p>
                All content and materials provided by the Association are the
                property of the Association. Members may not reproduce or
                distribute materials without prior written permission.
              </p>
              <h5>Amendments</h5>
              <p>
                The Association reserves the right to amend these Terms and
                Conditions at any time. Members will be notified of any changes
                via email or through our website.
              </p>
              <h5>Governing Law</h5>
              <p>
                These Terms and Conditions shall be governed by and construed in
                accordance with the laws of England and Wales
              </p>
              <h5>Contact Information</h5>
              <p>
                For questions or concerns regarding these Terms and Conditions,
                please contact us at: MSB Association
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default TermsConditions;
